<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/segment-icon-org.svg" alt="Segmentos" class="center-svg"/>
                        <h1 class="text-semibold t-24">Miembros del segmento</h1>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline">
                            <img src="assets/svg/edit.svg" alt="Vista resumen" width="16" height="16" />
                            Modificar Segmento
                        </button>
                        <button class="action-btn primary">
                            <img src="assets/svg/plus-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Enviar correo
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{members.length}} elementos | Se actualizó hace 2 minutos</span>
                </div>
                
                <div class="content-area mt-5">
                    <div *ngIf="members.length > 0">
                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Tipo</th>
                                        <th>Nombre</th>
                                        <th>Cargo</th>
                                        <th>Compañia</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of members; let i=index">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td>{{tipo}}</td>
                                        <td>{{item.nombre}} {{item.apellido}}</td>
                                        <td>{{item.cargo}}</td>
                                        <td>{{item.empresa}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + i)">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + i">
                                                    <button class="dropdown-item">Eliminar del segmento</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="members.length === 0" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                 <img src="assets/img/listaprospecto.png" alt="Lista de campanas vacía" />
                            </div>
                            <h2>Sin campañas por ahora</h2>
                            <p>Todavía no tienes campañas registradas. Puedes comenzar agregando una nueva.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>